import { PhoneCall, Target, Rocket, DollarSign, Activity } from "lucide-react";

const kpis = [
  {
    icon: PhoneCall,
    label: "Daily Dials Per Caller",
    value: "180 to 250",
    foot: "Sustained, QA-monitored",
  },
  {
    icon: Target,
    label: "Average Contact Rate",
    value: "11.4%",
    foot: "Across active campaigns",
  },
  {
    icon: Rocket,
    label: "Launch Time",
    value: "10 to 14 Days",
    foot: "Kickoff to live dials",
  },
  {
    icon: DollarSign,
    label: "Cost Reduction",
    value: "~70%",
    foot: "vs. US domestic hire",
  },
];

const pipeline = [
  { name: "Dials today", value: "1,284", pct: "w-[92%]" },
  { name: "Live contacts", value: "147", pct: "w-[58%]" },
  { name: "Qualified leads", value: "31", pct: "w-[34%]" },
  { name: "Appts booked", value: "9", pct: "w-[18%]" },
];

const PipelinePreview = () => {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute -inset-6 rounded-3xl bg-secondary/20 blur-3xl" />

      <div className="relative rounded-2xl border border-white/10 bg-[hsl(220_30%_8%)] p-5 shadow-2xl ring-1 ring-white/5">
        {/* Window chrome */}
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="ml-3 text-[11px] font-medium uppercase tracking-wider text-white/40">
              Live Acquisition Pipeline
            </span>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-secondary/40 bg-secondary/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-secondary">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-secondary" />
            Live
          </span>
        </div>

        {/* KPI grid */}
        <div className="grid grid-cols-2 gap-3">
          {kpis.map((k) => (
            <div
              key={k.label}
              className="rounded-lg border border-white/5 bg-white/[0.03] p-3.5"
            >
              <div className="flex items-center gap-2">
                <k.icon className="h-3.5 w-3.5 text-secondary" />
                <span className="text-[10px] font-semibold uppercase tracking-wider text-white/50">
                  {k.label}
                </span>
              </div>
              <div className="mt-2 font-display text-xl font-extrabold text-white">
                {k.value}
              </div>
              <div className="mt-0.5 text-[10px] text-white/40">{k.foot}</div>
            </div>
          ))}
        </div>

        {/* Pipeline funnel */}
        <div className="mt-4 rounded-lg border border-white/5 bg-white/[0.02] p-4">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-xs font-semibold text-white/80">Today's pipeline</span>
            <span className="text-[10px] text-white/40">Campaign · Absentee / DFW</span>
          </div>
          <div className="space-y-2.5">
            {pipeline.map((s) => (
              <div key={s.name}>
                <div className="mb-1 flex items-center justify-between text-[11px]">
                  <span className="text-white/70">{s.name}</span>
                  <span className="font-mono font-semibold text-white">{s.value}</span>
                </div>
                <div className="h-1.5 w-full rounded-full bg-white/5">
                  <div className={`h-full rounded-full bg-secondary ${s.pct}`} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-4 flex items-center justify-between rounded-lg border border-white/5 bg-white/[0.02] p-3 text-xs">
          <div className="flex items-center gap-2 text-white/70">
            <Activity className="h-3.5 w-3.5 text-secondary" />
            <span>Active placements · 32 US markets</span>
          </div>
          <span className="font-mono text-white/50">100% CRM-synced</span>
        </div>
      </div>
    </div>
  );
};

export default PipelinePreview;
